// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.digital-talent-page {
    background: #ffffff;
}

.digital-talent-section {
    padding-top: 44px;
    padding-bottom: 12px;
}

.digital-talent-page .digital-talent-section:last-of-type {
    padding-bottom: 44px;
}

.digital-talent-hero {
    position: relative;
    overflow: hidden;
    min-height: 64vh;
    display: flex;
    align-items: center;
    background:
        linear-gradient(135deg, rgba(10, 10, 12, 0.96), rgba(30, 12, 14, 0.92)),
        #0d0d10;
    color: #ffffff;
}

.digital-talent-hero-bg {
    position: absolute;
    inset: 0;
}

.digital-talent-grid {
    position: absolute;
    inset: -24%;
    background-image:
        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);
    background-size: 44px 44px;
    transform: perspective(720px) rotateX(64deg);
    animation: digitalTalentGridMove 24s linear infinite;
}

.digital-talent-glow {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 18% 24%, rgba(217, 0, 27, 0.2), transparent 24%),
        radial-gradient(circle at 82% 72%, rgba(255, 214, 214, 0.08), transparent 22%);
}

.digital-talent-hero-content {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);
    gap: 24px;
    align-items: center;
    padding-top: 128px;
    padding-bottom: 76px;
}

.digital-talent-hero-copy {
    max-width: 860px;
}

.digital-talent-kicker {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}

.digital-talent-hero-title {
    margin: 18px 0 14px;
    font-size: clamp(2.6rem, 5vw, 4.8rem);
    line-height: 1.02;
}

.digital-talent-page.is-ja .digital-talent-hero-title {
    font-size: clamp(2.2rem, 4.2vw, 4rem);
    white-space: nowrap;
}

.digital-talent-hero-subtitle {
    max-width: 620px;
    font-size: 1.08rem;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.82);
}

.digital-talent-block,
.digital-talent-process-card {
    border-radius: 24px;
    border: 1px solid rgba(217, 0, 27, 0.08);
    box-shadow: 0 14px 32px rgba(22, 22, 26, 0.05);
}

.digital-talent-block,
.digital-talent-process-card {
    background: rgba(255, 255, 255, 0.96);
    padding: 24px;
}

.digital-talent-hero-description {
    max-width: 760px;
    margin-top: 10px;
    color: rgba(255, 255, 255, 0.84);
    font-size: 1.02rem;
    line-height: 1.82;
}

.digital-talent-hero-highlight {
    display: grid;
    gap: 8px;
    max-width: 420px;
    padding: 20px 22px;
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.14);
    backdrop-filter: blur(12px);
    justify-self: end;
}

.digital-talent-hero-highlight p {
    color: rgba(255, 255, 255, 0.82);
    line-height: 1.75;
}

.digital-talent-block + .digital-talent-block {
    margin-top: 16px;
}

.digital-talent-subsection-head {
    margin-bottom: 14px;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 16px;
    align-items: center;
}

.digital-talent-subsection-header {
    margin-top: 28px;
    margin-bottom: 18px;
}

.digital-talent-block-mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 64px;
    height: 64px;
    padding: 0 14px;
    border-radius: 16px;
    background: #fff1f2;
    color: var(--accent-red);
    font-size: 2.8rem;
    font-weight: 950;
    line-height: 0.9;
    letter-spacing: -0.04em;
    box-shadow: inset 0 0 0 1px rgba(229, 1, 18, 0.06);
}

.digital-talent-subsection-head h3 {
    font-size: 1.8rem;
    line-height: 1.1;
    font-weight: 820;
    margin: 0;
    color: #343434;
}

.digital-talent-subsection-header h3,
.digital-talent-card-head h3 {
    font-size: 1.55rem;
    line-height: 1.2;
    font-weight: 800;
    margin-bottom: 4px;
}

html:lang(ja) .digital-talent-step-index,
html:lang(ja) .digital-talent-subsection-head h3,
html:lang(ja) .digital-talent-subsection-header h3,
html:lang(ja) .digital-talent-card-head h3,
html:lang(ja) .digital-talent-result-value {
    font-weight: 700;
}

.digital-talent-subsection-head > div:last-child {
    min-height: 64px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.digital-talent-subsection-head p,
.digital-talent-subsection-header p,
.digital-talent-card-head p {
    color: var(--text-main);
    font-weight: 600;
    line-height: 1.72;
}

.digital-talent-paragraph-stack {
    display: grid;
    gap: 10px;
}

.digital-talent-paragraph-stack p,
.digital-talent-step p,
.digital-talent-bullet,
.digital-talent-support-item p,
.digital-talent-result-card p {
    color: var(--text-light);
    line-height: 1.9;
}

.digital-talent-system-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    align-items: stretch;
    margin-top: 4px;
}

.digital-talent-system-panel {
    display: flex;
    flex-direction: column;
    padding: 16px 18px;
    border: 1px solid rgba(217, 0, 27, 0.14);
    border-radius: 18px;
    background: linear-gradient(180deg, #ffffff 0%, #fdf8f7 100%);
    box-shadow: 0 8px 18px rgba(22, 22, 26, 0.04);
    transition: border-color 0.24s ease, box-shadow 0.24s ease, transform 0.24s ease;
}

.digital-talent-system-panel.is-open {
    border-color: rgba(217, 0, 27, 0.2);
    box-shadow: 0 14px 30px rgba(22, 22, 26, 0.07);
}

.digital-talent-system-trigger {
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 16px;
    padding: 0;
    border: none;
    background: transparent;
    text-align: left;
    cursor: pointer;
}

.digital-talent-system-trigger:hover .digital-talent-system-toggle {
    border-color: rgba(217, 0, 27, 0.18);
    background: #fff4f5;
}

.digital-talent-card-head {
    margin-bottom: 4px;
}

.digital-talent-system-panel .digital-talent-card-head {
    margin-bottom: 14px;
}

.digital-talent-system-panel .digital-talent-card-head h3 {
    font-size: 1.18rem;
    line-height: 1.4;
    font-weight: 800;
    margin-bottom: 6px;
    color: #343434;
}

.digital-talent-system-toggle {
    position: relative;
    width: 42px;
    height: 42px;
    border-radius: 14px;
    border: 1px solid rgba(217, 0, 27, 0.1);
    background: #fff7f7;
    flex-shrink: 0;
    transition: transform 0.24s ease, background 0.24s ease, border-color 0.24s ease;
}

.digital-talent-system-toggle span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 14px;
    height: 2px;
    border-radius: 999px;
    background: var(--accent-red);
    transform: translate(-50%, -50%);
    transition: transform 0.24s ease, opacity 0.24s ease;
}

.digital-talent-system-toggle span:last-child {
    transform: translate(-50%, -50%) rotate(90deg);
}

.digital-talent-system-panel.is-open .digital-talent-system-toggle {
    transform: rotate(180deg);
}

.digital-talent-system-panel.is-open .digital-talent-system-toggle span:last-child {
    opacity: 0;
    transform: translate(-50%, -50%) rotate(90deg) scaleX(0.4);
}

.digital-talent-system-subtitle {
    font-size: 0.88rem;
    line-height: 1.7;
    color: var(--accent-red) !important;
    font-weight: 700 !important;
}

.digital-talent-system-collapse {
    margin-top: 10px;
    animation: digitalTalentAccordionIn 0.28s ease;
}

.digital-talent-system-collapse.is-open {
    opacity: 1;
}

.digital-talent-step-list {
    display: grid;
    gap: 10px;
    overflow: hidden;
}

.digital-talent-step {
    display: grid;
    grid-template-columns: 40px 1fr;
    gap: 12px;
    padding: 14px;
    border: 1px solid rgba(217, 0, 27, 0.08);
    background: rgba(255, 255, 255, 0.92);
    border-radius: 14px;
}

.digital-talent-step-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: #fff1f2;
    color: var(--accent-red);
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 0.08em;
}

.digital-talent-step-content {
    min-width: 0;
}

.digital-talent-step h4,
.digital-talent-support-item h4 {
    font-size: 0.99rem;
    line-height: 1.5;
    margin-bottom: 4px;
}

.digital-talent-step h4 {
    color: var(--text-main);
    font-weight: 700;
}

.digital-talent-bullet-list {
    display: grid;
    gap: 5px;
    margin-top: 6px;
    list-style: none;
}

.digital-talent-bullet-list-spacious {
    margin-top: 0;
}

.digital-talent-bullet {
    position: relative;
    padding-left: 14px;
}

.digital-talent-system-panel .digital-talent-step p,
.digital-talent-system-panel .digital-talent-bullet {
    line-height: 1.68;
    color: var(--text-light);
}

.digital-talent-bullet::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.9em;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--accent-red);
    transform: translateY(-50%);
}

.digital-talent-result-value {
    font-size: clamp(2.2rem, 4vw, 3.2rem);
    font-weight: 900;
    color: var(--accent-red);
    line-height: 1;
}

.digital-talent-support-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.digital-talent-support-item {
    padding: 16px;
    border-radius: 18px;
    border: 1px solid var(--border-color);
    background: linear-gradient(180deg, #ffffff 0%, #fbf8f6 100%);
}

.digital-talent-process-stack {
    display: grid;
    gap: 16px;
}

.digital-talent-career-cta {
    display: grid;
    justify-items: center;
    text-align: center;
    gap: 16px;
    padding: 30px 32px;
    border-radius: 26px;
    border: 1px solid rgba(217, 0, 27, 0.1);
    background:
        radial-gradient(circle at 50% 0%, rgba(217, 0, 27, 0.08), transparent 42%),
        linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #fff7f7 100%);
    box-shadow: 0 16px 36px rgba(22, 22, 26, 0.05);
}

.digital-talent-career-kicker {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}

.digital-talent-career-cta h2 {
    font-size: clamp(1.8rem, 3vw, 2.5rem);
    line-height: 1.15;
    color: var(--text-main);
}

.digital-talent-career-cta p {
    max-width: 760px;
    color: var(--text-light);
    line-height: 1.82;
}

.digital-talent-career-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 220px;
    padding: 15px 28px;
    border-radius: 999px;
    background: var(--accent-red);
    color: #ffffff;
    font-weight: 700;
    transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;
    box-shadow: 0 12px 24px rgba(217, 0, 27, 0.18);
}

.digital-talent-career-link:hover {
    background: var(--accent-red-hover);
    transform: translateY(-2px);
    box-shadow: 0 16px 28px rgba(217, 0, 27, 0.22);
}

.digital-talent-process-content {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid var(--border-color);
    display: grid;
    gap: 14px;
}

.digital-talent-note-box {
    display: grid;
    gap: 8px;
}

.digital-talent-split-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 220px;
    gap: 18px;
    align-items: stretch;
}

.digital-talent-platform-layout {
    grid-template-columns: minmax(0, 1fr) 200px;
    gap: 16px;
}

.digital-talent-platform-copy {
    display: grid;
    gap: 12px;
    align-content: start;
}

.digital-talent-platform-lead {
    padding: 16px 18px;
    border-radius: 18px;
    background: linear-gradient(180deg, #ffffff 0%, #fbf8f6 100%);
    border: 1px solid rgba(217, 0, 27, 0.08);
    color: var(--text-main) !important;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.82 !important;
}

.digital-talent-platform-note {
    padding: 16px 18px;
    border-radius: 18px;
    background: #fff7f7;
    border: 1px solid rgba(217, 0, 27, 0.08);
}

.digital-talent-platform-note p {
    color: var(--text-light);
    line-height: 1.82;
}

.digital-talent-split-layout-compact {
    grid-template-columns: minmax(0, 1fr) 200px;
}

.digital-talent-side-visual {
    width: 100%;
}

.digital-talent-visual-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
    border-radius: 18px;
}

.digital-talent-visual-image-tall {
    min-height: 100%;
}

.digital-talent-support-visual {
    width: 100%;
    height: 100%;
    min-height: 220px;
    display: grid;
    gap: 12px;
    align-content: center;
    padding: 16px;
    border-radius: 18px;
    background:
        radial-gradient(circle at 22% 20%, rgba(255, 255, 255, 0.4), transparent 24%),
        linear-gradient(180deg, #fff3f4 0%, #ffe6e8 100%);
    border: 1px solid rgba(217, 0, 27, 0.08);
}

.digital-talent-support-visual-card {
    display: grid;
    gap: 8px;
    padding: 12px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.88);
    border: 1px solid rgba(217, 0, 27, 0.08);
}

.digital-talent-support-visual-card-main {
    grid-template-columns: 34px 1fr;
    align-items: center;
    gap: 12px;
}

.digital-talent-support-visual-badge {
    width: 34px;
    height: 34px;
    border-radius: 12px;
    background: linear-gradient(180deg, #ef5a68 0%, #ff7d8a 100%);
    box-shadow: 0 8px 18px rgba(239, 90, 104, 0.22);
}

.digital-talent-support-visual-lines {
    display: grid;
    gap: 8px;
}

.digital-talent-support-visual-lines span,
.digital-talent-support-visual-card span {
    display: block;
    height: 8px;
    border-radius: 999px;
    background: rgba(160, 74, 92, 0.22);
}

.digital-talent-support-visual-lines .is-short,
.digital-talent-support-visual-card .is-short {
    width: 64%;
}

.digital-talent-support-visual-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}

.digital-talent-support-visual-flow {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.digital-talent-support-visual-pill {
    flex: 1 1 46px;
    height: 28px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.86);
    border: 1px solid rgba(217, 0, 27, 0.08);
}

.digital-talent-placeholder {
    width: 100%;
    height: 100%;
    display: block;
    background: #d1d5db;
    border-radius: 18px;
}

.digital-talent-placeholder-tall {
    min-height: 100%;
}

.digital-talent-placeholder-square {
    min-height: 220px;
}

@keyframes digitalTalentGridMove {
    from {
        transform: perspective(720px) rotateX(64deg) translateY(0);
    }

    to {
        transform: perspective(720px) rotateX(64deg) translateY(44px);
    }
}

@keyframes digitalTalentAccordionIn {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 992px) {
    .digital-talent-hero-content,
    .digital-talent-system-grid,
    .digital-talent-support-grid,
    .digital-talent-split-layout,
    .digital-talent-split-layout-compact {
        grid-template-columns: 1fr;
    }

    .digital-talent-side-visual {
        width: 100%;
    }

    .digital-talent-platform-layout {
        grid-template-columns: 1fr;
    }

    .digital-talent-placeholder-tall {
        min-height: 220px;
    }

    .digital-talent-visual-image-tall,
    .digital-talent-support-visual {
        min-height: 220px;
    }
}

@media (max-width: 768px) {
    .digital-talent-section {
        padding-top: 36px;
    }

    .digital-talent-section.section-container {
        width: min(94%, 1400px);
    }

    .digital-talent-hero-content {
        padding-top: 118px;
        padding-bottom: 60px;
    }

    .digital-talent-block,
    .digital-talent-process-card {
        padding: 18px;
        border-radius: 18px;
    }

    .digital-talent-block + .digital-talent-block {
        margin-top: 16px;
    }

    .digital-talent-support-grid {
        grid-template-columns: 1fr;
    }

    .digital-talent-subsection-head {
        grid-template-columns: auto 1fr;
        gap: 12px;
        align-items: center;
        margin-bottom: 12px;
    }

    .digital-talent-block-mark {
        min-width: 46px;
        width: fit-content;
        height: 46px;
        padding: 0 10px;
        border-radius: 12px;
        font-size: 2.15rem;
        line-height: 0.9;
    }

    .digital-talent-subsection-head > div:last-child {
        min-height: 46px;
    }

    .digital-talent-subsection-head h3 {
        font-size: 1.45rem;
        margin: 0;
    }

    .digital-talent-system-grid {
        gap: 12px;
    }

    .digital-talent-system-panel {
        padding: 14px;
        border-radius: 14px;
    }

    .digital-talent-system-trigger {
        gap: 12px;
    }

    .digital-talent-system-panel .digital-talent-card-head {
        margin-bottom: 9px;
    }

    .digital-talent-system-panel .digital-talent-card-head h3 {
        font-size: 1.03rem;
    }

    .digital-talent-step {
        grid-template-columns: 34px 1fr;
        gap: 10px;
        padding: 12px;
    }

    .digital-talent-step-index {
        width: 34px;
        height: 34px;
        border-radius: 10px;
    }

    .digital-talent-system-toggle {
        width: 38px;
        height: 38px;
        border-radius: 12px;
    }

    .digital-talent-step h4 {
        font-size: 0.92rem;
        margin-bottom: 4px;
    }

    .digital-talent-step p,
    .digital-talent-bullet {
        line-height: 1.72;
    }

    .digital-talent-bullet-list {
        gap: 6px;
        margin-top: 6px;
    }

    .digital-talent-page.is-ja .digital-talent-hero-title {
        white-space: normal;
    }

    .digital-talent-placeholder-tall,
    .digital-talent-placeholder-square {
        min-height: 180px;
    }

    .digital-talent-visual-image-tall,
    .digital-talent-support-visual {
        min-height: 180px;
    }

    .digital-talent-platform-lead,
    .digital-talent-platform-note {
        padding: 14px 16px;
        border-radius: 16px;
    }

    .digital-talent-career-cta {
        padding: 22px 18px;
        border-radius: 18px;
    }

    .digital-talent-career-link {
        width: 100%;
        min-width: 0;
    }
}

@media (prefers-reduced-motion: reduce) {
    .digital-talent-system-panel,
    .digital-talent-system-toggle,
    .digital-talent-system-toggle span,
    .digital-talent-system-collapse {
        transition: none;
        animation: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/digital-talent.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB;;eAEW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;;+EAE2E;IAC3E,0BAA0B;IAC1B,4CAA4C;IAC5C,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;;sFAEkF;AACtF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;;IAEI,mBAAmB;IACnB,wCAAwC;IACxC,8CAA8C;AAClD;;AAEA;;IAEI,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,2CAA2C;IAC3C,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,kDAAkD;AACtD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;;;;IAKI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;IAGI,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;;;;IAKI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,6DAA6D;IAC7D,6CAA6C;IAC7C,gFAAgF;AACpF;;AAEA;IACI,mCAAmC;IACnC,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,cAAc;IACd,gFAAgF;AACpF;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,6BAA6B;IAC7B,gCAAgC;IAChC,oDAAoD;AACxD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,0DAA0D;AAC9D;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,aAAa;IACb,wCAAwC;IACxC,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,6DAA6D;AACjE;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC;;2EAEuE;IACvE,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,8EAA8E;IAC9E,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;IACzC,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,2CAA2C;IAC3C,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6DAA6D;IAC7D,wCAAwC;IACxC,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB;;yDAEqD;IACrD,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6DAA6D;IAC7D,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,mCAAmC;AACvC;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,0DAA0D;IAC9D;;IAEA;QACI,6DAA6D;IACjE;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;;;;;QAKI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;;QAEI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,+BAA+B;QAC/B,SAAS;QACT,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,+BAA+B;QAC/B,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;;;;QAII,gBAAgB;QAChB,eAAe;IACnB;AACJ","sourcesContent":[".digital-talent-page {\r\n    background: #ffffff;\r\n}\r\n\r\n.digital-talent-section {\r\n    padding-top: 44px;\r\n    padding-bottom: 12px;\r\n}\r\n\r\n.digital-talent-page .digital-talent-section:last-of-type {\r\n    padding-bottom: 44px;\r\n}\r\n\r\n.digital-talent-hero {\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-height: 64vh;\r\n    display: flex;\r\n    align-items: center;\r\n    background:\r\n        linear-gradient(135deg, rgba(10, 10, 12, 0.96), rgba(30, 12, 14, 0.92)),\r\n        #0d0d10;\r\n    color: #ffffff;\r\n}\r\n\r\n.digital-talent-hero-bg {\r\n    position: absolute;\r\n    inset: 0;\r\n}\r\n\r\n.digital-talent-grid {\r\n    position: absolute;\r\n    inset: -24%;\r\n    background-image:\r\n        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),\r\n        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);\r\n    background-size: 44px 44px;\r\n    transform: perspective(720px) rotateX(64deg);\r\n    animation: digitalTalentGridMove 24s linear infinite;\r\n}\r\n\r\n.digital-talent-glow {\r\n    position: absolute;\r\n    inset: 0;\r\n    background:\r\n        radial-gradient(circle at 18% 24%, rgba(217, 0, 27, 0.2), transparent 24%),\r\n        radial-gradient(circle at 82% 72%, rgba(255, 214, 214, 0.08), transparent 22%);\r\n}\r\n\r\n.digital-talent-hero-content {\r\n    position: relative;\r\n    z-index: 1;\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);\r\n    gap: 24px;\r\n    align-items: center;\r\n    padding-top: 128px;\r\n    padding-bottom: 76px;\r\n}\r\n\r\n.digital-talent-hero-copy {\r\n    max-width: 860px;\r\n}\r\n\r\n.digital-talent-kicker {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.12em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.digital-talent-hero-title {\r\n    margin: 18px 0 14px;\r\n    font-size: clamp(2.6rem, 5vw, 4.8rem);\r\n    line-height: 1.02;\r\n}\r\n\r\n.digital-talent-page.is-ja .digital-talent-hero-title {\r\n    font-size: clamp(2.2rem, 4.2vw, 4rem);\r\n    white-space: nowrap;\r\n}\r\n\r\n.digital-talent-hero-subtitle {\r\n    max-width: 620px;\r\n    font-size: 1.08rem;\r\n    line-height: 1.8;\r\n    color: rgba(255, 255, 255, 0.82);\r\n}\r\n\r\n.digital-talent-block,\r\n.digital-talent-process-card {\r\n    border-radius: 24px;\r\n    border: 1px solid rgba(217, 0, 27, 0.08);\r\n    box-shadow: 0 14px 32px rgba(22, 22, 26, 0.05);\r\n}\r\n\r\n.digital-talent-block,\r\n.digital-talent-process-card {\r\n    background: rgba(255, 255, 255, 0.96);\r\n    padding: 24px;\r\n}\r\n\r\n.digital-talent-hero-description {\r\n    max-width: 760px;\r\n    margin-top: 10px;\r\n    color: rgba(255, 255, 255, 0.84);\r\n    font-size: 1.02rem;\r\n    line-height: 1.82;\r\n}\r\n\r\n.digital-talent-hero-highlight {\r\n    display: grid;\r\n    gap: 8px;\r\n    max-width: 420px;\r\n    padding: 20px 22px;\r\n    border-radius: 22px;\r\n    background: rgba(255, 255, 255, 0.08);\r\n    border: 1px solid rgba(255, 255, 255, 0.14);\r\n    backdrop-filter: blur(12px);\r\n    justify-self: end;\r\n}\r\n\r\n.digital-talent-hero-highlight p {\r\n    color: rgba(255, 255, 255, 0.82);\r\n    line-height: 1.75;\r\n}\r\n\r\n.digital-talent-block + .digital-talent-block {\r\n    margin-top: 16px;\r\n}\r\n\r\n.digital-talent-subsection-head {\r\n    margin-bottom: 14px;\r\n    display: grid;\r\n    grid-template-columns: auto 1fr;\r\n    gap: 16px;\r\n    align-items: center;\r\n}\r\n\r\n.digital-talent-subsection-header {\r\n    margin-top: 28px;\r\n    margin-bottom: 18px;\r\n}\r\n\r\n.digital-talent-block-mark {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 64px;\r\n    height: 64px;\r\n    padding: 0 14px;\r\n    border-radius: 16px;\r\n    background: #fff1f2;\r\n    color: var(--accent-red);\r\n    font-size: 2.8rem;\r\n    font-weight: 950;\r\n    line-height: 0.9;\r\n    letter-spacing: -0.04em;\r\n    box-shadow: inset 0 0 0 1px rgba(229, 1, 18, 0.06);\r\n}\r\n\r\n.digital-talent-subsection-head h3 {\r\n    font-size: 1.8rem;\r\n    line-height: 1.1;\r\n    font-weight: 820;\r\n    margin: 0;\r\n    color: #343434;\r\n}\r\n\r\n.digital-talent-subsection-header h3,\n.digital-talent-card-head h3 {\n    font-size: 1.55rem;\n    line-height: 1.2;\r\n    font-weight: 800;\r\n    margin-bottom: 4px;\n}\n\nhtml:lang(ja) .digital-talent-step-index,\nhtml:lang(ja) .digital-talent-subsection-head h3,\nhtml:lang(ja) .digital-talent-subsection-header h3,\nhtml:lang(ja) .digital-talent-card-head h3,\nhtml:lang(ja) .digital-talent-result-value {\n    font-weight: 700;\n}\n\r\n.digital-talent-subsection-head > div:last-child {\r\n    min-height: 64px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n.digital-talent-subsection-head p,\r\n.digital-talent-subsection-header p,\r\n.digital-talent-card-head p {\r\n    color: var(--text-main);\r\n    font-weight: 600;\r\n    line-height: 1.72;\r\n}\r\n\r\n.digital-talent-paragraph-stack {\r\n    display: grid;\r\n    gap: 10px;\r\n}\r\n\r\n.digital-talent-paragraph-stack p,\r\n.digital-talent-step p,\r\n.digital-talent-bullet,\r\n.digital-talent-support-item p,\r\n.digital-talent-result-card p {\r\n    color: var(--text-light);\r\n    line-height: 1.9;\r\n}\r\n\r\n.digital-talent-system-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 12px;\r\n    align-items: stretch;\r\n    margin-top: 4px;\r\n}\r\n\r\n.digital-talent-system-panel {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 16px 18px;\r\n    border: 1px solid rgba(217, 0, 27, 0.14);\r\n    border-radius: 18px;\r\n    background: linear-gradient(180deg, #ffffff 0%, #fdf8f7 100%);\r\n    box-shadow: 0 8px 18px rgba(22, 22, 26, 0.04);\r\n    transition: border-color 0.24s ease, box-shadow 0.24s ease, transform 0.24s ease;\r\n}\r\n\r\n.digital-talent-system-panel.is-open {\r\n    border-color: rgba(217, 0, 27, 0.2);\r\n    box-shadow: 0 14px 30px rgba(22, 22, 26, 0.07);\r\n}\r\n\r\n.digital-talent-system-trigger {\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1fr) auto;\r\n    align-items: center;\r\n    gap: 16px;\r\n    padding: 0;\r\n    border: none;\r\n    background: transparent;\r\n    text-align: left;\r\n    cursor: pointer;\r\n}\r\n\r\n.digital-talent-system-trigger:hover .digital-talent-system-toggle {\r\n    border-color: rgba(217, 0, 27, 0.18);\r\n    background: #fff4f5;\r\n}\r\n\r\n.digital-talent-card-head {\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.digital-talent-system-panel .digital-talent-card-head {\r\n    margin-bottom: 14px;\r\n}\r\n\r\n.digital-talent-system-panel .digital-talent-card-head h3 {\r\n    font-size: 1.18rem;\r\n    line-height: 1.4;\r\n    font-weight: 800;\r\n    margin-bottom: 6px;\r\n    color: #343434;\r\n}\r\n\r\n.digital-talent-system-toggle {\r\n    position: relative;\r\n    width: 42px;\r\n    height: 42px;\r\n    border-radius: 14px;\r\n    border: 1px solid rgba(217, 0, 27, 0.1);\r\n    background: #fff7f7;\r\n    flex-shrink: 0;\r\n    transition: transform 0.24s ease, background 0.24s ease, border-color 0.24s ease;\r\n}\r\n\r\n.digital-talent-system-toggle span {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 14px;\r\n    height: 2px;\r\n    border-radius: 999px;\r\n    background: var(--accent-red);\r\n    transform: translate(-50%, -50%);\r\n    transition: transform 0.24s ease, opacity 0.24s ease;\r\n}\r\n\r\n.digital-talent-system-toggle span:last-child {\r\n    transform: translate(-50%, -50%) rotate(90deg);\r\n}\r\n\r\n.digital-talent-system-panel.is-open .digital-talent-system-toggle {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.digital-talent-system-panel.is-open .digital-talent-system-toggle span:last-child {\r\n    opacity: 0;\r\n    transform: translate(-50%, -50%) rotate(90deg) scaleX(0.4);\r\n}\r\n\r\n.digital-talent-system-subtitle {\r\n    font-size: 0.88rem;\r\n    line-height: 1.7;\r\n    color: var(--accent-red) !important;\r\n    font-weight: 700 !important;\r\n}\r\n\r\n.digital-talent-system-collapse {\r\n    margin-top: 10px;\r\n    animation: digitalTalentAccordionIn 0.28s ease;\r\n}\r\n\r\n.digital-talent-system-collapse.is-open {\r\n    opacity: 1;\r\n}\r\n\r\n.digital-talent-step-list {\r\n    display: grid;\r\n    gap: 10px;\r\n    overflow: hidden;\r\n}\r\n\r\n.digital-talent-step {\r\n    display: grid;\r\n    grid-template-columns: 40px 1fr;\r\n    gap: 12px;\r\n    padding: 14px;\r\n    border: 1px solid rgba(217, 0, 27, 0.08);\r\n    background: rgba(255, 255, 255, 0.92);\r\n    border-radius: 14px;\r\n}\r\n\r\n.digital-talent-step-index {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 12px;\r\n    background: #fff1f2;\r\n    color: var(--accent-red);\r\n    font-size: 0.8rem;\r\n    font-weight: 800;\r\n    letter-spacing: 0.08em;\r\n}\r\n\r\n.digital-talent-step-content {\r\n    min-width: 0;\r\n}\r\n\r\n.digital-talent-step h4,\r\n.digital-talent-support-item h4 {\r\n    font-size: 0.99rem;\r\n    line-height: 1.5;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.digital-talent-step h4 {\r\n    color: var(--text-main);\r\n    font-weight: 700;\r\n}\r\n\r\n.digital-talent-bullet-list {\r\n    display: grid;\r\n    gap: 5px;\r\n    margin-top: 6px;\r\n    list-style: none;\r\n}\r\n\r\n.digital-talent-bullet-list-spacious {\r\n    margin-top: 0;\r\n}\r\n\r\n.digital-talent-bullet {\r\n    position: relative;\r\n    padding-left: 14px;\r\n}\r\n\r\n.digital-talent-system-panel .digital-talent-step p,\r\n.digital-talent-system-panel .digital-talent-bullet {\r\n    line-height: 1.68;\r\n    color: var(--text-light);\r\n}\r\n\r\n.digital-talent-bullet::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0.9em;\r\n    width: 7px;\r\n    height: 7px;\r\n    border-radius: 50%;\r\n    background: var(--accent-red);\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.digital-talent-result-value {\r\n    font-size: clamp(2.2rem, 4vw, 3.2rem);\r\n    font-weight: 900;\r\n    color: var(--accent-red);\r\n    line-height: 1;\r\n}\r\n\r\n.digital-talent-support-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 14px;\r\n}\r\n\r\n.digital-talent-support-item {\r\n    padding: 16px;\r\n    border-radius: 18px;\r\n    border: 1px solid var(--border-color);\r\n    background: linear-gradient(180deg, #ffffff 0%, #fbf8f6 100%);\r\n}\r\n\r\n.digital-talent-process-stack {\r\n    display: grid;\r\n    gap: 16px;\r\n}\r\n\r\n.digital-talent-career-cta {\r\n    display: grid;\r\n    justify-items: center;\r\n    text-align: center;\r\n    gap: 16px;\r\n    padding: 30px 32px;\r\n    border-radius: 26px;\r\n    border: 1px solid rgba(217, 0, 27, 0.1);\r\n    background:\r\n        radial-gradient(circle at 50% 0%, rgba(217, 0, 27, 0.08), transparent 42%),\r\n        linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #fff7f7 100%);\r\n    box-shadow: 0 16px 36px rgba(22, 22, 26, 0.05);\r\n}\r\n\r\n.digital-talent-career-kicker {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.12em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.digital-talent-career-cta h2 {\r\n    font-size: clamp(1.8rem, 3vw, 2.5rem);\r\n    line-height: 1.15;\r\n    color: var(--text-main);\r\n}\r\n\r\n.digital-talent-career-cta p {\r\n    max-width: 760px;\r\n    color: var(--text-light);\r\n    line-height: 1.82;\r\n}\r\n\r\n.digital-talent-career-link {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 220px;\r\n    padding: 15px 28px;\r\n    border-radius: 999px;\r\n    background: var(--accent-red);\r\n    color: #ffffff;\r\n    font-weight: 700;\r\n    transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;\r\n    box-shadow: 0 12px 24px rgba(217, 0, 27, 0.18);\r\n}\r\n\r\n.digital-talent-career-link:hover {\r\n    background: var(--accent-red-hover);\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 16px 28px rgba(217, 0, 27, 0.22);\r\n}\r\n\r\n.digital-talent-process-content {\r\n    margin-top: 14px;\r\n    padding-top: 14px;\r\n    border-top: 1px solid var(--border-color);\r\n    display: grid;\r\n    gap: 14px;\r\n}\r\n\r\n.digital-talent-note-box {\r\n    display: grid;\r\n    gap: 8px;\r\n}\r\n\r\n.digital-talent-split-layout {\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1fr) 220px;\r\n    gap: 18px;\r\n    align-items: stretch;\r\n}\r\n\r\n.digital-talent-platform-layout {\r\n    grid-template-columns: minmax(0, 1fr) 200px;\r\n    gap: 16px;\r\n}\r\n\r\n.digital-talent-platform-copy {\r\n    display: grid;\r\n    gap: 12px;\r\n    align-content: start;\r\n}\r\n\r\n.digital-talent-platform-lead {\r\n    padding: 16px 18px;\r\n    border-radius: 18px;\r\n    background: linear-gradient(180deg, #ffffff 0%, #fbf8f6 100%);\r\n    border: 1px solid rgba(217, 0, 27, 0.08);\r\n    color: var(--text-main) !important;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    line-height: 1.82 !important;\r\n}\r\n\r\n.digital-talent-platform-note {\r\n    padding: 16px 18px;\r\n    border-radius: 18px;\r\n    background: #fff7f7;\r\n    border: 1px solid rgba(217, 0, 27, 0.08);\r\n}\r\n\r\n.digital-talent-platform-note p {\r\n    color: var(--text-light);\r\n    line-height: 1.82;\r\n}\r\n\r\n.digital-talent-split-layout-compact {\r\n    grid-template-columns: minmax(0, 1fr) 200px;\r\n}\r\n\r\n.digital-talent-side-visual {\r\n    width: 100%;\r\n}\r\n\r\n.digital-talent-visual-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    object-fit: cover;\r\n    object-position: center;\r\n    border-radius: 18px;\r\n}\r\n\r\n.digital-talent-visual-image-tall {\r\n    min-height: 100%;\r\n}\r\n\r\n.digital-talent-support-visual {\r\n    width: 100%;\r\n    height: 100%;\r\n    min-height: 220px;\r\n    display: grid;\r\n    gap: 12px;\r\n    align-content: center;\r\n    padding: 16px;\r\n    border-radius: 18px;\r\n    background:\r\n        radial-gradient(circle at 22% 20%, rgba(255, 255, 255, 0.4), transparent 24%),\r\n        linear-gradient(180deg, #fff3f4 0%, #ffe6e8 100%);\r\n    border: 1px solid rgba(217, 0, 27, 0.08);\r\n}\r\n\r\n.digital-talent-support-visual-card {\r\n    display: grid;\r\n    gap: 8px;\r\n    padding: 12px;\r\n    border-radius: 14px;\r\n    background: rgba(255, 255, 255, 0.88);\r\n    border: 1px solid rgba(217, 0, 27, 0.08);\r\n}\r\n\r\n.digital-talent-support-visual-card-main {\r\n    grid-template-columns: 34px 1fr;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n\r\n.digital-talent-support-visual-badge {\r\n    width: 34px;\r\n    height: 34px;\r\n    border-radius: 12px;\r\n    background: linear-gradient(180deg, #ef5a68 0%, #ff7d8a 100%);\r\n    box-shadow: 0 8px 18px rgba(239, 90, 104, 0.22);\r\n}\r\n\r\n.digital-talent-support-visual-lines {\r\n    display: grid;\r\n    gap: 8px;\r\n}\r\n\r\n.digital-talent-support-visual-lines span,\r\n.digital-talent-support-visual-card span {\r\n    display: block;\r\n    height: 8px;\r\n    border-radius: 999px;\r\n    background: rgba(160, 74, 92, 0.22);\r\n}\r\n\r\n.digital-talent-support-visual-lines .is-short,\r\n.digital-talent-support-visual-card .is-short {\r\n    width: 64%;\r\n}\r\n\r\n.digital-talent-support-visual-row {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 10px;\r\n}\r\n\r\n.digital-talent-support-visual-flow {\r\n    display: flex;\r\n    gap: 8px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.digital-talent-support-visual-pill {\r\n    flex: 1 1 46px;\r\n    height: 28px;\r\n    border-radius: 999px;\r\n    background: rgba(255, 255, 255, 0.86);\r\n    border: 1px solid rgba(217, 0, 27, 0.08);\r\n}\r\n\r\n.digital-talent-placeholder {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    background: #d1d5db;\r\n    border-radius: 18px;\r\n}\r\n\r\n.digital-talent-placeholder-tall {\r\n    min-height: 100%;\r\n}\r\n\r\n.digital-talent-placeholder-square {\r\n    min-height: 220px;\r\n}\r\n\r\n@keyframes digitalTalentGridMove {\r\n    from {\r\n        transform: perspective(720px) rotateX(64deg) translateY(0);\r\n    }\r\n\r\n    to {\r\n        transform: perspective(720px) rotateX(64deg) translateY(44px);\r\n    }\r\n}\r\n\r\n@keyframes digitalTalentAccordionIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-4px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .digital-talent-hero-content,\r\n    .digital-talent-system-grid,\r\n    .digital-talent-support-grid,\r\n    .digital-talent-split-layout,\r\n    .digital-talent-split-layout-compact {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .digital-talent-side-visual {\r\n        width: 100%;\r\n    }\r\n\r\n    .digital-talent-platform-layout {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .digital-talent-placeholder-tall {\r\n        min-height: 220px;\r\n    }\r\n\r\n    .digital-talent-visual-image-tall,\r\n    .digital-talent-support-visual {\r\n        min-height: 220px;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .digital-talent-section {\r\n        padding-top: 36px;\r\n    }\r\n\r\n    .digital-talent-section.section-container {\r\n        width: min(94%, 1400px);\r\n    }\r\n\r\n    .digital-talent-hero-content {\r\n        padding-top: 118px;\r\n        padding-bottom: 60px;\r\n    }\r\n\r\n    .digital-talent-block,\r\n    .digital-talent-process-card {\r\n        padding: 18px;\r\n        border-radius: 18px;\r\n    }\r\n\r\n    .digital-talent-block + .digital-talent-block {\r\n        margin-top: 16px;\r\n    }\r\n\r\n    .digital-talent-support-grid {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .digital-talent-subsection-head {\r\n        grid-template-columns: auto 1fr;\r\n        gap: 12px;\r\n        align-items: center;\r\n        margin-bottom: 12px;\r\n    }\r\n\r\n    .digital-talent-block-mark {\r\n        min-width: 46px;\r\n        width: fit-content;\r\n        height: 46px;\r\n        padding: 0 10px;\r\n        border-radius: 12px;\r\n        font-size: 2.15rem;\r\n        line-height: 0.9;\r\n    }\r\n\r\n    .digital-talent-subsection-head > div:last-child {\r\n        min-height: 46px;\r\n    }\r\n\r\n    .digital-talent-subsection-head h3 {\r\n        font-size: 1.45rem;\r\n        margin: 0;\r\n    }\r\n\r\n    .digital-talent-system-grid {\r\n        gap: 12px;\r\n    }\r\n\r\n    .digital-talent-system-panel {\r\n        padding: 14px;\r\n        border-radius: 14px;\r\n    }\r\n\r\n    .digital-talent-system-trigger {\r\n        gap: 12px;\r\n    }\r\n\r\n    .digital-talent-system-panel .digital-talent-card-head {\r\n        margin-bottom: 9px;\r\n    }\r\n\r\n    .digital-talent-system-panel .digital-talent-card-head h3 {\r\n        font-size: 1.03rem;\r\n    }\r\n\r\n    .digital-talent-step {\r\n        grid-template-columns: 34px 1fr;\r\n        gap: 10px;\r\n        padding: 12px;\r\n    }\r\n\r\n    .digital-talent-step-index {\r\n        width: 34px;\r\n        height: 34px;\r\n        border-radius: 10px;\r\n    }\r\n\r\n    .digital-talent-system-toggle {\r\n        width: 38px;\r\n        height: 38px;\r\n        border-radius: 12px;\r\n    }\r\n\r\n    .digital-talent-step h4 {\r\n        font-size: 0.92rem;\r\n        margin-bottom: 4px;\r\n    }\r\n\r\n    .digital-talent-step p,\r\n    .digital-talent-bullet {\r\n        line-height: 1.72;\r\n    }\r\n\r\n    .digital-talent-bullet-list {\r\n        gap: 6px;\r\n        margin-top: 6px;\r\n    }\r\n\r\n    .digital-talent-page.is-ja .digital-talent-hero-title {\r\n        white-space: normal;\r\n    }\r\n\r\n    .digital-talent-placeholder-tall,\r\n    .digital-talent-placeholder-square {\r\n        min-height: 180px;\r\n    }\r\n\r\n    .digital-talent-visual-image-tall,\r\n    .digital-talent-support-visual {\r\n        min-height: 180px;\r\n    }\r\n\r\n    .digital-talent-platform-lead,\r\n    .digital-talent-platform-note {\r\n        padding: 14px 16px;\r\n        border-radius: 16px;\r\n    }\r\n\r\n    .digital-talent-career-cta {\r\n        padding: 22px 18px;\r\n        border-radius: 18px;\r\n    }\r\n\r\n    .digital-talent-career-link {\r\n        width: 100%;\r\n        min-width: 0;\r\n    }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n    .digital-talent-system-panel,\r\n    .digital-talent-system-toggle,\r\n    .digital-talent-system-toggle span,\r\n    .digital-talent-system-collapse {\r\n        transition: none;\r\n        animation: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
